import initHeader from "./layout/header"
import initCategoriesSidebar from "./layout/categories-sidebar"
import initSingleProduct from "./layout/single-product"
import initSlider from "./blocks/slider"
import initTopProducts from "./blocks/top-products"
import initDiscountBlock from "./blocks/discount"


initHeader()
initCategoriesSidebar()
initSingleProduct()
initSlider()
initTopProducts()
initDiscountBlock()
